import { lazy } from "react";

import { createDependencyInjectableComponent } from "@faire/retailer/app/_lib/dependencyInjectableComponent";

const LazyLoggedInCategoryPageBase = lazy(() =>
  import(
    /* webpackChunkName: "category-page" */ "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/LoggedInCategoryPageBase"
  ).then((m) => ({ default: m.LoggedInCategoryPageBase }))
);
const {
  useDependencyInjectableComponent: useLoggedInCategoryPageBase,
  DependencyInjectableComponentProvider: LoggedInCategoryPageBaseProvider,
} = createDependencyInjectableComponent(LazyLoggedInCategoryPageBase);

export { useLoggedInCategoryPageBase, LoggedInCategoryPageBaseProvider };
